(() => {
  const STEP = 10;
  const MIN = 10;

  function normalize(n) {
    n = parseInt(String(n || ''), 10);
    if (isNaN(n) || n < MIN) return MIN;
    return Math.max(MIN, Math.round(n / STEP) * STEP);
  }

  // Toast
  function toast(msg = 'Hinzugefügt') {
    let t = document.querySelector('.qa10-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'qa10-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => t.classList.remove('is-visible'), 1600);
  }

  // Lock gegen Doppel-Add
  function isBusy(el) {
    return el?.dataset?.qa10Busy === 'true';
  }
  function setBusy(el, state) {
    if (!el) return;
    el.dataset.qa10Busy = state ? 'true' : 'false';
  }

  async function ajaxAdd(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity })
    });

    if (!res.ok) {
      const err = await res.json().catch(() => null);
      console.error('QA10 add failed:', err || res.statusText);
      toast('Fehler beim Hinzufügen');
      return false;
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return true;
  }

  // ---- Robust: erkenne alle Card Quick-Add Forms (Collection + Related Products) ----
  // Prestige nutzt häufig: form[is="product-form"] + action="/cart/add"
  // In Related Products kann is="product-form" fehlen oder action anders (mit query)
  function isCardAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;

    const action = (form.getAttribute('action') || '').toLowerCase();
    if (!action.includes('/cart/add')) return false;

    // Muss innerhalb einer product-card sein (Collection + Related Products)
    const card = form.closest('product-card, .product-card');
    if (!card) return false;

    // Muss eine Variant-ID haben
    const id = form.querySelector('input[name="id"]')?.value;
    if (!id) return false;

    return true;
  }

  function setHiddenQty(form, qty) {
    let q = form.querySelector('input[name="quantity"]');
    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      form.appendChild(q);
    }
    q.value = String(qty);
  }

  function getQtyFromUIOrDefault(form) {
    const valEl = form.querySelector('[data-qa10-val]');
    if (valEl) return normalize(valEl.textContent);
    return MIN;
  }

  function ensureUI(form) {
    if (!isCardAddForm(form)) return;

    // schon gemacht?
    if (form.classList.contains('qa10-form') && form.querySelector('.qa10-qty')) return;

    const addBtn = form.querySelector('.product-card__quick-add-button, button[type="submit"], button[name="add"]');
    if (!addBtn) return;

    // Klasse setzen (damit dein CSS greifen kann)
    form.classList.add('qa10-form');

    // Stepper nur einmal einfügen
    if (!form.querySelector('.qa10-qty')) {
      const qtyWrap = document.createElement('div');
      qtyWrap.className = 'qa10-qty';
      qtyWrap.innerHTML = `
        <button type="button" class="qa10-qty__btn" data-qa10-minus aria-label="Weniger">−</button>
        <span class="qa10-qty__val" data-qa10-val>${MIN}</span>
        <button type="button" class="qa10-qty__btn" data-qa10-plus aria-label="Mehr">+</button>
      `;

      // vor dem Add-Button platzieren
      addBtn.parentNode.insertBefore(qtyWrap, addBtn);

      // initial qty
      setHiddenQty(form, MIN);
    }

    // Drawer/redirect Trigger neutralisieren falls vorhanden
    const onSuccess = form.querySelector('input[name="on_success"]');
    if (onSuccess) onSuccess.value = '';
  }

  function init(root = document) {
    // Wichtig: nicht nur product-card forms mit is="product-form"
    // sondern alle Forms innerhalb von product-card, die /cart/add haben
    const forms = root.querySelectorAll('product-card form, .product-card form');
    forms.forEach(ensureUI);
  }

  // Stepper +/- handler
  document.addEventListener(
    'click',
    (e) => {
      const minus = e.target.closest?.('[data-qa10-minus]');
      const plus = e.target.closest?.('[data-qa10-plus]');
      if (!minus && !plus) return;

      const form = e.target.closest?.('form');
      if (!isCardAddForm(form)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const valEl = form.querySelector('[data-qa10-val]');
      if (!valEl) return;

      let current = normalize(valEl.textContent);
      current = plus ? current + STEP : Math.max(MIN, current - STEP);

      valEl.textContent = String(current);
      setHiddenQty(form, current);
    },
    true
  );

  // Add Button click handler (nimmt submit/redirect komplett raus)
  document.addEventListener(
    'click',
    async (e) => {
      // der echte Quick-Add Button im Prestige Card
      const btn = e.target.closest?.('.product-card__quick-add-button, form.qa10-form button[type="submit"], form.qa10-form button[name="add"]');
      if (!btn) return;

      const form = btn.closest('form');
      if (!isCardAddForm(form)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      ensureUI(form);

      if (isBusy(form)) return;
      setBusy(form, true);

      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId) {
        setBusy(form, false);
        return;
      }

      const qty = getQtyFromUIOrDefault(form);
      setHiddenQty(form, qty);

      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      try {
        const ok = await ajaxAdd(variantId, qty);
        if (ok) toast(`Hinzugefügt (${qty})`);
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        setBusy(form, false);
      }
    },
    true
  );

  // Submit block (falls Theme/App submit auslöst)
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!isCardAddForm(form)) return;

      // wenn unser UI vorhanden ist, blocken wir submit komplett
      if (form.querySelector('[data-qa10-val]')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  // MutationObserver: Related Products lädt nachträglich – wir initialisieren nach
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;

        // Wenn product-recommendations neue Cards reinsetzt
        if (node.matches?.('product-card, .product-card, product-recommendations') || node.querySelector?.('product-card, .product-card, product-recommendations')) {
          init(node);
        }
      }
    }
  });
  mo.observe(document.documentElement, { subtree: true, childList: true });

  // Start
  init();
})();
